import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService, ResourceService } from '@services/index.service';
import { AppConstants } from '@app/appConstants';
import { ResponseDataBase } from '@interfaces/index.interface';
declare var $: any;

import { environment } from "@environments/environment";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.page.html',
  styleUrls: ['./user-management.page.scss'],
  animations: environment.ANIMATIONS
})
export class UserManagementComponent implements OnInit {

  searchForm: FormGroup;
  searchedUsers;
  alert;
  selectedUser;
  editedMail;
  modalAlert;
  formaPass: FormGroup;
  registerOnlyWithPin = environment.REGISTER_ONLY_WITH_PIN;
  lockReason;

  newAdmin: any = {
    id: null,
    email: null,
    password: null,
    portalRole: 'admin',
    language: environment.DEFAULTLANGUAGE,
    phoneNumber: "666666666"
  };

  newUserRemovingDependency: any = {
    id: null,
    email: null,
    password: null
  };

  constructor(public _userService: UserService,
    public _resourceService: ResourceService,
    public translate: TranslateService) {
    this.searchForm = new FormGroup({
      'phoneNumber': new FormControl(),
      'docNumber': new FormControl(),
      'name': new FormControl(),
      'lastname': new FormControl(),
      'email': new FormControl(),
      'isLocked': new FormControl()
    });
    this.formaPass = new FormGroup({
      "password": new FormControl("", [
        Validators.required
      ]),
      "confirmpassword": new FormControl("", [
        Validators.required
      ]),
    });
    this.formaPass.controls["confirmpassword"].setValidators([
      this.notEqualPassword.bind(this.formaPass)
    ]);
    this._resourceService.loading = false;
  }

  /** Comprueba que las passwords a modificar sean iguales */
  notEqualPassword(control: FormControl): { [s: string]: boolean } {
    const forma: any = this;
    if (control.value !== forma.controls["password"].value) {
      return {
        notEqualsPass: true
      };
    }
    return null;
  }

  clearSearchedUsers() {
    delete this.searchedUsers;
  }


  searchUsers() {
    if (!this.searchForm.value.name && !this.searchForm.value.email &&
      !this.searchForm.value.docNumber && !this.searchForm.value.phoneNumber && !this.searchForm.value.lastname) {
      this.alert = 'PLEASE_FILL_AT_LEAST_ONE_FIELD'
    } else {
      delete this.alert;
      delete this.searchedUsers;
      this._resourceService.loading = true;
      let params: any = {};
      if (this.searchForm.value.name) { params.name = this.searchForm.value.name };
      if (this.searchForm.value.email) { params.email = this.searchForm.value.email };
      if (this.searchForm.value.lastname) { params.lastname = this.searchForm.value.lastname };
      if (this.searchForm.value.docNumber) { params.docnumber = this.searchForm.value.docNumber };
      if (this.searchForm.value.phoneNumber) { params.phonenumber = this.searchForm.value.phoneNumber };
      if (this.searchForm.value.isLocked) { params.isLocked = this.searchForm.value.isLocked };
      this._userService.searchUsers(params).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          if (!response.result.length) {
            this.alert = 'NO_RESULTS'
          } else {
            this.searchedUsers = response.result;
          }
        } else {
          this.alert = response.METADATA.ERROR_MESSAGE;
        }
        this._resourceService.loading = false;
      });
    }
  }

  addAdminUser() {
    delete this._resourceService.alert;
    if (!this._resourceService.validateEmail(this.newAdmin.email)) {
      this._resourceService.alert = "THE_EMAIL_IS_NOT_VALID";
    } else {
      if (!this.newAdmin.id) {
        this._resourceService.alert = "PLEASE_FILL_FIELDS_MARKS_WITH";
      } else {
        this._userService.registerAdminUser(this.newAdmin).subscribe(data => {
          let response = data as ResponseDataBase;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            $('#AddAdminModal').modal('hide');
            window.scrollTo(0, 0);
            this.alert = 'THE_ADMIN_USERS_HAS_BEEN_CREATED';
            delete this._resourceService.alert;
            this.newAdmin = {
              id: null,
              email: null,
              password: null,
              portalRole: 'admin',
              language: environment.DEFAULTLANGUAGE,
              phoneNumber: "666666666"
            };
          } else {
            this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
            window.scrollTo(0, 0);
          }
          this._userService.loading = false;
        });
      }

    }
  }

  selectUser(user) {
    this.selectedUser = user;
  }

  removeDependency() {
    this.newUserRemovingDependency.id = this.selectedUser.id;
    delete this._resourceService.alert;
    if (!this._resourceService.validateEmail(this.newUserRemovingDependency.email)) {
      this._resourceService.alert = "THE_EMAIL_IS_NOT_VALID";
    } else {
      this._userService.removeDependency(this.newUserRemovingDependency).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          $('#RemoveDependencyModal').modal('hide');
          delete this.searchedUsers;
          window.scrollTo(0, 0);
          this.alert = 'THE_DEPENDENCY_HAS_BEEN_REMOVED';
          delete this._resourceService.alert;
          this.newUserRemovingDependency = {
            email: null,
            password: null
          };
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
          window.scrollTo(0, 0);
        }
        this._userService.loading = false;
      });
    }
  }

  deleteUser() {
    let params = {
      userId: this.selectedUser.id
    }
    this._userService.deleteUser(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        delete this.searchedUsers;
        this.translate.get('HAS_BEEN_DELETED').subscribe(
          translation => {
            let name = this.selectedUser.name ? this.selectedUser.name : this.selectedUser.role
            this.alert = name + " " + translation;
          });
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.loading = false;
        window.scrollTo(0, 0);
      }
    });
  }

  lockUser(user) {
    this.selectedUser = user;
    let params = {
      email: this.selectedUser.email,
      lockReason: this.lockReason
    }
    this._userService.lockUser(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        delete this.searchedUsers;
        this.translate.get('HAS_BEEN_LOCKED').subscribe(
          translation => {
            this.alert = this.selectedUser.name + " " + this.selectedUser.lastname + " " + translation;
          });
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.loading = false;
      }
    });
  }

  unlockUser(user) {
    this.selectedUser = user;
    let params = {
      email: this.selectedUser.email
    }
    this._userService.unlockUser(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        delete this.searchedUsers;
        this.translate.get('HAS_BEEN_UNLOCKED').subscribe(
          translation => {
            this.alert = this.selectedUser.name + " " + this.selectedUser.lastname + " " + translation;
          });
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.loading = false;
      }
    });
  }

  changeUserRole(user, role) {
    this.selectedUser = user;
    let params = {
      id: this.selectedUser.id,
      portalRole: role
    }
    this._userService.changeUserRole(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        delete this.searchedUsers;
        this.translate.get('NOW_HAS_ROLE').subscribe(
          translation => {
            this.alert = this.selectedUser.email + " " + translation + ": " + role;
          });
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._userService.loading = false;
      }
    });
  }

  changeUserPass() {
    console.log('environment', environment.envName);
    if (environment.envName == 'typet') {
      if (!this._resourceService.validateTypetPasswordwithUserName(this.formaPass.controls.password.value, this.selectedUser.email)) {
        this._userService.danger = "THE_PASSWORD_MUST_HAVE";
      } else {
        this.executechangeUserPass();
      }
    } else {
      if (!this._resourceService.validatePassword(this.formaPass.controls.password.value)) {
        this._userService.danger = "THE_PASSWORD_MUST_HAVE";
      } else {
        this.executechangeUserPass();
      }
    }



  }

  executechangeUserPass() {
    let params = {
      password: this.formaPass.controls.password.value,
      id: this.selectedUser.id
    };
    this._userService.changeUserPass(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        $('#ChangePassModal').modal('hide');
        delete this.searchedUsers;
        this.alert = 'USER_PASS_CHANGED';
      } else {
        this.alert = 'Your password could not be changed';
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });
  }

  editUser(user) {
    this.selectedUser = user;
  }

  updateUser() {
    delete this.modalAlert;
    if (!this.editedMail) {
      this.modalAlert = "NO_CHANGES_IN_USER_INFORMATION";
    } else {
      if (this._resourceService.validateEmail(this.editedMail)) {
        let params = {
          email: this.editedMail,
          id: this.selectedUser.id
        };
        this._userService.changeUserMail(params).subscribe(data => {
          let response = data as ResponseDataBase;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            delete this.searchedUsers;
            this.alert = 'EMAIL_SUCCESSFULLY_CHANGE';
            $('#EditedUserModal').modal('hide');
          } else {
            this.alert = 'EMAIL_COULD_NOT_BE_CHANGED';
            $('#EditedUserModal').modal('hide');
          }
          this._userService.loading = false;
        });
      } else {
        this.modalAlert = "THE_EMAIL_IS_NOT_VALID";
      }
    }
  }

  print() {
    window.print();
  }

  printDivById(idName) {
    var printContents = document.getElementById(idName).innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  printDivByClass(className) {
    var printContents = '';
    var list = document.getElementsByClassName(className);
    for (var i = 0; i < list.length; i++) {
      printContents += list[i].innerHTML;
    }
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  ngOnInit() {
  }

}
